module.exports = "<div ng-mouseover=\"$ctrl.showAccounts()\" ng-mouseleave=\"$ctrl.hideAccounts()\"><span data-key=\"{{$ctrl.dkey}}\" class=\"\">{{$ctrl.alias}}</span><div><table class=\"account-menu\"><tr><th>{{::'Пользователь' | gettext}}</th><th>{{::'Полное имя' | gettext}}</th><th>{{::'Адрес' | gettext}}</th><th>&nbsp;</th></tr><tr ng-repeat=\"acc in $ctrl.accounts\"><td>{{acc.user_name}}</td><td>{{acc.full_name}}</td><td>{{$ctrl.accountKey}}</td><td><a sc-xref=\"{{'/admin/agent/account/' + acc.id}}/\"><i class=\"icon-cogs\"></i></a></td></tr></table></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/account/account.component.html
// module id = 853
// module chunks = 0